function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.5 6h-20C4.125 6 3.013 7.157 3.013 8.571L3 21.43C3 22.843 4.125 24 5.5 24h20c1.375 0 2.5-1.157 2.5-2.571V8.57C28 7.157 26.875 6 25.5 6zM14.25 9.857h2.5v2.572h-2.5V9.857zm0 3.857h2.5v2.572h-2.5v-2.572zM10.5 9.857H13v2.572h-2.5V9.857zm0 3.857H13v2.572h-2.5v-2.572zm-1.25 2.572h-2.5v-2.572h2.5v2.572zm0-3.857h-2.5V9.857h2.5v2.572zm11.25 9h-10v-2.572h10v2.572zm0-5.143H18v-2.572h2.5v2.572zm0-3.857H18V9.857h2.5v2.572zm3.75 3.857h-2.5v-2.572h2.5v2.572zm0-3.857h-2.5V9.857h2.5v2.572z",
  fill: "#222",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h30v30H0V0zm0 0h30v30H0V0z"
}))));